module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_8023.71c29f3c.png";